import React, { useState } from 'react'
import {
  Card,
  Table,
  Button,
  Input,
  Divider,
  Collapse,
  Row,
  Col,
  Modal,
  Form,
  Tooltip,
  message,
  Spin,
  Select,
  Upload,
  Space
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import { useHistory } from 'react-router-dom'
import { InputGroup } from 'reactstrap'
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  SearchOutlined,
  TagFilled,
  DownOutlined,
  PlusCircleOutlined,
  FunnelPlotOutlined,
  LoadingOutlined,
  PlusOutlined,
  EyeInvisibleOutlined,
  EyeTwoTone
} from '@ant-design/icons'
import { userLogOut } from '../../../appRedux/actions/Auth'
import { loadStoreChange } from '../../../appRedux/actions/Setup'
import { useStore, useDispatch, useSelector } from 'react-redux'
import { loadData } from '../../../appRedux/actions/Setting'
import _ from 'lodash'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import { USERROLES_SCREEN } from '../../../constants/Pages'
import {
  READ,
  CREATE,
  UPDATE,
  DELETE
} from '../../../constants/RightsAndPermissions'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import {
  checkPasswordStrength,
  isEmailValid,
  notAllowMsgCheck,
  verifyPkgFeature
} from '../../../appRedux/actions/GlobalMethods'
import { checkIsWeb } from '../../../appRedux/actions/MobAppFn'
import NotAllowedComponent from '../../../components/NotAllowedComponent'
import { PkgFeatures } from '../../../constants/StoreEntities'

const confirm = Modal.confirm

function getBase64 (img, callback) {
  // ;
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}

function beforeUpload (file) {
  // ;
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
  if (!isJpgOrPng) {
    message.error('You can only upload JPG/PNG file!')
  }
  const isLt2M = file.size / 1024 / 1024 < 2
  if (!isLt2M) {
    message.error('Image must smaller than 2MB!')
  }
  return isJpgOrPng && isLt2M
}

const AddEditUser = ({ match }) => {
  const getUserId = match.params.id ? match.params.id : false
  const showdelete = match.params.showdelete ? match.params.showdelete : false
  const store = useStore()
  const dispatch = useDispatch()
  const history = useHistory()
  const [form] = Form.useForm()

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )

  const [getOutletsDeSelect, setOutletsDeSelect] = useState([])
  const [loading, setLoading] = useState(false)
  const [imageUrl, setimageUrl] = useState(false)
  const [getOutletsData, setOutletsData] = useState([])
  const [getRolesData, setRolesData] = useState([])
  const [getIsLoading, setIsLoading] = React.useState(true)
  const [getImageFile, setImageFile] = React.useState({})
  // const [getUserId, setUserId] = React.useState(false);
  const [getIsOwner, setIsOwner] = React.useState(false)
  const [getIsLoggedInOwner, setIsLoggedInOwner] = React.useState(false)
  const [getIsImageUpdated, setIsImageUpdated] = useState(false)
  const [getIsImageExist, setIsImageExist] = useState(false)
  const [getCurrSymbol, setCurrSymbol] = React.useState('')
  const [getIsAllowRead, setIsAllowRead] = React.useState(false)
  const [getIsDisableCreate, setIsDisableCreate] = React.useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = React.useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = React.useState(true)
  const [getAccessLoading, setAccessLoading] = React.useState(true)
  const [getRights, setRights] = React.useState([])
  const [getPermissions, setPermissions] = React.useState([])
  const [passwordStatus, setPasswordState] = React.useState('1')
  const [isFeatureAllowed, setIsFeatureAllowed] = useState(true)

  React.useEffect(() => {
    // ;
    // form.setFieldsValue({outlets: ['1','2']});
    // form.setFieldsValue({outlets: 'asd'},{outlets: 'qwe'});
    // let url = window.location.href.split("addedit/");
    // let id = url.length > 1 ? url[1] : false;
    // setUserId(id);
    // setOutletsData(outlets);
    // setRolesData(roles);
    // form.setFieldsValue({ roles: roles[0].id });
    dispatch(setCommonConfigs(USERROLES_SCREEN))
    getOutletsService()
    getRolesService()
    if (getUserId) {
      getUsersDataService(getUserId)
      if (!verifyPkgFeature(PkgFeatures.CustomUserRoles)) {
        setIsFeatureAllowed(false)
      }
    }
  }, [])

  //rights & permissions
  React.useEffect(() => {
    let commonData = getReduxCommonSetting
    let rites = []
    let permissions = []
    if (
      commonData &&
      commonData.storeCommonConfigs &&
      commonData.storeCommonConfigs.storeConfig &&
      commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
    ) {
      if (commonData.storeCommonConfigs.storeConfig.currencyData) {
        let currencyData =
          commonData.storeCommonConfigs.storeConfig.currencyData
        setCurrSymbol(currencyData.currencySymbol)
      }
      if (
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites &&
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
          .length > 0
      ) {
        rites =
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
        setRights(rites)
      }
      if (
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
          .permission &&
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
          .permission.length > 0
      ) {
        permissions =
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
        setPermissions(permissions)
      }
    }

    if (rites.length > 0) {
      if (rites.filter(a => a == READ).length > 0) {
        setIsAllowRead(true)
      }
      if (rites.filter(a => a == CREATE).length > 0) {
        setIsDisableCreate(false)
      }
      if (rites.filter(a => a == UPDATE).length > 0) {
        setIsDisableUpdate(false)
      }
      if (rites.filter(a => a == DELETE).length > 0) {
        setIsDisableDelete(false)
      }
    }

    if (commonData && commonData.storeCommonConfigs) {
      setAccessLoading(false)
    }
  }, [getReduxCommonSetting])

  async function postUsersService (body, methodType, featureID) {
    const postUsers = ds.postUsers(body, methodType, featureID ? featureID : '')
    await postUsers
      .then(response => {
        if (response.status == 200) {
          if (response.data.msgCode == 'GENERAL_SUCCESS') {
            dispatch(loadStoreChange(true))
            message.success('Saved Successfully')
            if (
              response.data.data &&
              response.data.data.includes('picUpdated/')
            ) {
              let url = response.data.data.split('picUpdated/')
              url = url && url.length > 1 ? url[1] : ''
              if (url != '') {
                localStorage.setItem('profileImage', url)
              }
            }
            dispatch(loadData(true))
            setTimeout(() => {
              setIsLoading(false)
              history.push('/dashboard/setup/users/listing')
            }, 2000)
          } else {
            setIsLoading(false)
            if (response.data.msgCode == 'REG_FIELD_NOT_VALID') {
              message.error(response.data.msgDescription, 5)
            } else {
              message.error('Something Went Wrong...')
            }
          }
        } else {
          setIsLoading(false)
          message.error('Something Went Wrong...')
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setIsLoading(false)
      })
  }

  async function getRolesService () {
    // ;
    const getRoles = ds.getRolesList('', BEHAVIOUR_TYPE.GET)
    await getRoles
      .then(response => {
        if (response.status == 200) {
          if (response.data.msgCode == 'GENERAL_SUCCESS') {
            if (response.data.data) {
              let data = response.data.data
              let rolesData = data.map(e => {
                return {
                  role: e.roleName,
                  id: e.sRoleId.substring(0, e.sRoleId.indexOf('&'))
                }
              })
              setRolesData(rolesData)
              // form.setFieldsValue({ roles: rolesData[0].id });
            } else {
              setIsLoading(false)
              message.error('Something Went Wrong...')
            }
          } else {
            setIsLoading(false)
            message.error('Something Went Wrong...')
          }
        } else {
          setIsLoading(false)
          message.error('Something Went Wrong...')
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setIsLoading(false)
        // if (e.response && e.response.status === 401) {
        //   message.error("Token Expired! Redirecting to Login Page");
        //   setTimeout(() => {
        //     dispatch(userLogOut(store.getState()));
        //   }, 3000);
        // } else {
        //   message.error("Something Went Wrong...");
        // }
      })
  }

  async function getOutletsService () {
    const getOutlets = ds.getStoreOutlets()
    await getOutlets
      .then(response => {
        if (!getUserId) {
          setIsLoading(false)
        }
        if (response.status == 200) {
          if (response.data.msgCode == 'GENERAL_SUCCESS') {
            if (response.data.data) {
              let data = response.data.data
              let outletData = data.map(e => {
                return {
                  id: e.sOutletId.substring(0, e.sOutletId.indexOf('&')),
                  outlet: e.outletName
                }
              })
              setOutletsData(outletData)
            } else {
              setIsLoading(false)
              message.error('Something Went Wrong...')
            }
          } else {
            setIsLoading(false)
            message.error('Something Went Wrong...')
          }
        } else {
          setIsLoading(false)
          message.error('Something Went Wrong...')
        }
      })
      .catch(e => {
        setIsLoading(false)
        // if (e.response && e.response.status === 401) {
        //   message.error("Token Expired! Redirecting to Login Page");
        //   setTimeout(() => {
        //     dispatch(userLogOut(store.getState()));
        //   }, 3000);
        // } else {
        //   message.error("Something Went Wrong...");
        // }
      })
  }

  async function getUsersDataService (id) {
    let body = {
      SId: id
    }
    const getUsersData = ds.getUserByID(body, BEHAVIOUR_TYPE.GET)
    await getUsersData
      .then(response => {
        setIsLoading(false)
        if (response.status == 200) {
          if (response.data.msgCode == 'GENERAL_SUCCESS') {
            if (response.data.data && response.data.data.length > 0) {
              let data = response.data.data[0]
              setIsOwner(data.isOwner ? true : false)
              setIsLoggedInOwner(data.isLoggedInOwner ? true : false)
              let outlets = []
              let role = ''
              if (data.sRoleId) {
                role = data.sRoleId.substring(0, data.sRoleId.indexOf('&'))
              }
              for (let i = 0; i < data.sAssignedOutletId.length; i++) {
                let id = data.sAssignedOutletId[i].substring(
                  0,
                  data.sAssignedOutletId[i].indexOf('&')
                )
                let findItem = outlets.find(x => x === id)
                if (!findItem) outlets.push(id)
                // outlets.push(id);
              }
              if (data.imageUrl) {
                setimageUrl(data.imageUrl)
                setIsImageExist(data.imageUrl != '' ? true : false)
              }
              form.setFieldsValue({ userName: data.userName })
              form.setFieldsValue({ displayName: data.displayName })
              form.setFieldsValue({ email: data.emailAddress })
              form.setFieldsValue({ outlets: outlets })
              form.setFieldsValue({ roles: role })
            } else {
              message.error('Something Went Wrong...')
            }
          } else {
            message.error('Something Went Wrong...')
          }
        } else {
          message.error('Something Went Wrong...')
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setIsLoading(false)
      })
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
      md: { span: 24 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
      md: { span: 24 }
    }
  }

  const onFinish = async values => {
    if (!getUserId) {
      if (
        values.password &&
        values.password == values.confirm &&
        values.displayName &&
        values.userName &&
        values.outlets.length &&
        values.roles
      ) {
        setIsLoading(true)
        console.log('Roles', values)
        const body = new FormData()
        body.append('userName', values.userName)
        body.append('displayName', values.displayName)
        body.append('email', values.email)
        body.append('password', values.password)
        body.append('roleID', values.roles)
        // body.append("outletId", values.outlets);
        for (let i = 0; i < values.outlets.length; i++) {
          body.append('outletId', values.outlets[i])
        }
        body.append('UserImage', getImageFile)
        body.append('behavior', 1)
        postUsersService(body, BEHAVIOUR_TYPE.POST, PkgFeatures.RetailPOS)
      } else {
        message.error('Kindly Attend To Missing Field')
      }
    } else {
      if (
        values.displayName &&
        values.userName
        // && values.outlets.length &&
        // values.roles
      ) {
        setIsLoading(true)
        const body = new FormData()
        body.append('userName', values.userName)
        body.append('displayName', values.displayName)
        body.append('email', values.email)
        body.append('userID', getUserId)
        // body.append("outletId", values.outlets);
        if (!getIsOwner) {
          body.append('roleID', values.roles)
          for (let i = 0; i < values.outlets.length; i++) {
            body.append('outletId', values.outlets[i])
          }
        }
        body.append('UserImage', getImageFile)
        body.append(
          'IsImageUpdated',
          getIsImageUpdated && getUserId && getIsImageExist ? true : false
        )
        body.append('behavior', 3)
        if (values.password) {
          if (values.password == values.confirm) {
            body.append('password', values.password)
          } else {
            message.error('Password & Confirm Password not same, retry...')
            return
          }
        }
        postUsersService(
          body,
          BEHAVIOUR_TYPE.UPDATE,
          PkgFeatures.CustomUserRoles
        )
      } else {
        message.error('Kindly Attend To Missing Field')
      }
    }
  }

  const onFinishFailed = errorInfo => {
    //;
    message.error('Kindly Attend To Missing Field')
  }

  function handleCancel () {
    message.success('cancel')
  }

  function getCardUserName (evt) {
    //;
    // message.warn("username");
  }

  function getCardDisplayName (evt) {
    //;
    // message.warn("username");
  }

  function getCardEmail (evt) {
    //;
    // message.warning("emial");
  }

  // const handleChange = (info) => {
  //   // ;
  //   // if (info.file.status === "uploading") {
  //   //   setLoading(true);
  //   //   return;
  //   // }
  //   // if (info.file.status === "done") {
  //   //   // Get this url from response in real world.
  //   //   getBase64(info.file.originFileObj, (imageUrl) => {
  //   //     setimageUrl(imageUrl);
  //   //     setLoading(false);
  //   //   });
  //   // }
  //   setImageFile(info.file.originFileObj);
  //   setLoading(true);

  //   let reader = new FileReader();
  //   reader.readAsDataURL(info.file.originFileObj);

  //   setTimeout(() => {
  //     setimageUrl(reader.result);
  //     setLoading(false);
  //   }, 2000);
  // };

  const handleUpload = info => {
    setLoading(true)
    if (getUserId && getIsImageExist) {
      setIsImageUpdated(true)
    }
    let type = info.file.type
    const isJpgOrPng = type === 'image/jpeg' || type === 'image/png'
    if (isJpgOrPng) {
      var reader = new FileReader()
      //Read the contents of Image File.
      reader.readAsDataURL(info.file.originFileObj)
      reader.onload = function (e) {
        //Initiate the JavaScript Image object.
        var image = new Image()

        //Set the Base64 string return from FileReader as source.
        image.src = e.target.result

        //Validate the File Height and Width.
        image.onload = function () {
          var height = this.height
          var width = this.width
          setImageFile(info.file.originFileObj)
          let fileReader = new FileReader()
          fileReader.readAsDataURL(info.file.originFileObj)
          setTimeout(() => {
            setimageUrl(fileReader.result)
            setLoading(false)
          }, 2000)
          // if (height < 281 || width < 281) {
          //   setImageFile(info.file.originFileObj);
          //   let fileReader = new FileReader();
          //   fileReader.readAsDataURL(info.file.originFileObj);
          //   setTimeout(() => {
          //     setimageUrl(fileReader.result);
          //     setLoading(false);
          //   }, 2000);
          // } else {
          //   message.warn("Height and Width must not greater than 280px.", 4);
          //   setLoading(false);
          //   setimageUrl("");
          // }
        }
      }
    } else {
      message.error('You can only upload JPG/PNG file!')
      setLoading(false)
    }
  }

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>
        <IntlMessages id='sidebar.dataEntry.upload' />
      </div>
    </div>
  )

  function onDeleteBtn () {
    if (getUserId) {
      const body = new FormData()
      body.append('behavior', 2)
      body.append('userID', getUserId)
      body.append('userName', 'a')
      body.append('displayName', 'a')
      body.append('email', 'a')
      postUsersService(body, BEHAVIOUR_TYPE.DELETE)
    } else {
      message.warn('Kindly first select a user to delete')
    }
  }

  function showDeleteConfirm () {
    confirm({
      title: "Are you sure you want to delete this 'USER'?",
      content:
        "By doing so you are going to delete this 'USER' from the system!",
      okText: 'Yes',
      cancelText: 'No',
      okButtonProps: { className: 'dk-btn-add close-reg-btn' },
      cancelButtonProps: { className: 'dk-btn-cancel close-reg-btn' },
      onOk () {
        onDeleteBtn()
      },
      onCancel () {
        //console.log('Cancel');
      }
    })
  }

  function onPassChange (e) {
    const result = checkPasswordStrength(e.target.value)
    setPasswordState(result)
  }

  return getIsAllowRead && isFeatureAllowed ? (
    <>
      <div className='Content-wrapper Createuser-pg'>
        <div className='back-arrow-h1'>
          <h1 className='d-flex align-items-center'>
            <ArrowLeftOutlined
              className='dk-vertical-align'
              onClick={() => {
                history.push('/dashboard/setup/users/listing')
              }}
            />
            <span className='mx-2'>
              {' '}
              {getUserId ? (
                <IntlMessages id='user.scree.edituser' />
              ) : (
                <IntlMessages id='setup.usersedit.head' />
              )}
            </span>
          </h1>
        </div>

        <Row className='ant-row dk-row-bg-color m-0 Sec-heading-bg'>
          <Col lg={18} md={16} sm={14} xs={24}>
            <p className='title vd-hero-intro custom-font-color-black m-0'>
              <IntlMessages id='setup.usersedit.head2' />
            </p>
          </Col>
          <Col lg={6} md={8} sm={10} xs={24}>
            <div className='pg-header-btn'>
              {getUserId && !getIsOwner && (
                <Button
                  onClick={() => showDeleteConfirm()}
                  className='dk-btn-cancel'
                  type='primary'
                  disabled={getIsDisableDelete}
                  // disabled={showdelete == "0" ? true : false}
                  size='large'
                >
                  <IntlMessages id='setup.userroles.delete' />
                </Button>
              )}
              <Button
                className='dk-btn-add'
                htmlType='submit'
                type='primary'
                form='userForm'
                disabled={getUserId ? getIsDisableUpdate : getIsDisableCreate}
                size='large'
              >
                <IntlMessages id='setup.usersedit.save' />
              </Button>
            </div>
          </Col>
        </Row>

        <Spin
          tip={<IntlMessages id='setup.usersedit.loadscreen' />}
          spinning={getIsLoading}
          size='large'
          style={{ display: 'block' }}
        >
          <div className='custom-mg-top-25'>
            <Form
              {...formItemLayout}
              form={form}
              name='userForm'
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              className='Add-ant-form'
              scrollToFirstError
            >
              <Row className='Profile-div'>
                <Col lg={6} md={24} sm={24} xs={24}>
                  <h2 class='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                    <IntlMessages id='setup.usersedit.profile' />
                  </h2>
                  <p className='dk-font-size-15'>
                    <IntlMessages id='setup.usersedit.profilebrief' />
                  </p>
                </Col>

                <Col lg={18} md={24} sm={24} xs={24}>
                  <Row>
                    <Col md={12} xs={24}>
                      <Form.Item
                        className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment form-inner-pad-0'
                        name='userName'
                        label={<IntlMessages id='setup.usersedit.username' />}
                        rules={[
                          {
                            required: true,
                            message: (
                              <IntlMessages id='setup.usersedit.usernamerule' />
                            )
                          }
                        ]}
                      >
                        <Input
                          placeholder='User Name'
                          onChange={getCardUserName}
                          disabled={
                            getIsOwner && !getIsLoggedInOwner ? true : false
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col md={12} xs={24}>
                      <Form.Item
                        className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment form-inner-pad-0'
                        name='displayName'
                        label={
                          <IntlMessages id='setup.usersedit.userdisplayname' />
                        }
                        rules={[
                          {
                            required: true,
                            message: (
                              <IntlMessages id='setup.usersedit.userdisplaynamerule' />
                            )
                          }
                        ]}
                      >
                        <Input
                          placeholder='Display Name'
                          onChange={getCardDisplayName}
                          disabled={
                            getIsOwner && !getIsLoggedInOwner ? true : false
                          }
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={12} xs={24}>
                      <Form.Item
                        className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment form-inner-pad-0'
                        name='email'
                        label={<IntlMessages id='setup.usersedit.email' />}
                        rules={[
                          {
                            required: true,
                            message: (
                              <IntlMessages id='setup.usersedit.emailnecessary' />
                            )
                          },
                          {
                            validator: isEmailValid
                          }
                        ]}
                      >
                        <Input
                          disabled={
                            getIsOwner && !getIsLoggedInOwner ? true : false
                          }
                          placeholder='Email'
                          onChange={getCardEmail}
                        />
                      </Form.Item>
                    </Col>
                    <Col md={12} xs={24}></Col>
                  </Row>

                  <div className='mt-3'>
                    <h3 class='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                      <IntlMessages id='setup.usersedit.profileimage' />
                    </h3>
                    <Upload
                      name='avatar'
                      listType='picture-card'
                      className='avatar-uploader'
                      showUploadList={false}
                      // action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                      // beforeUpload={beforeUpload}
                      onChange={handleUpload}
                    >
                      {imageUrl ? (
                        <img
                          src={imageUrl}
                          alt='avatar'
                          style={{ width: '100%' }}
                        />
                      ) : (
                        uploadButton
                      )}
                    </Upload>
                    {imageUrl && (
                      <p style={{ marginTop: '26px' }}>
                        <IntlMessages id='setup.userroles.changeimg' />
                      </p>
                    )}
                  </div>
                </Col>
              </Row>

              <Divider className='mt-3 mb-4' />

              {!getIsOwner && (
                <>
                  <Row className='Outlets-div'>
                    <Col lg={6} md={24} sm={24} xs={24}>
                      <h2 class='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                        <IntlMessages id='setup.usersedit.outlets' />
                      </h2>
                      <p className='dk-font-size-15'>
                        <IntlMessages id='setup.usersedit.outletsbrief' />
                      </p>
                    </Col>

                    <Col lg={18} md={24} sm={24} xs={24}>
                      <Form.Item
                        className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment form-inner-pad-0'
                        name='outlets'
                        label={<IntlMessages id='setup.usersedit.outlets' />}
                        rules={[
                          {
                            required: true,
                            message: (
                              <IntlMessages id='setup.usersedit.outletsrule' />
                            )
                          }
                        ]}
                      >
                        <Select
                          placeholder='Select an Outlet'
                          mode='multiple'
                          size='large'
                          onDeselect={e =>
                            setOutletsDeSelect(getOutletsDeSelect.concat(e))
                          }
                          showSearch={checkIsWeb().exist}
                          optionFilterProp='children'
                        >
                          {getOutletsData &&
                            getOutletsData.length &&
                            getOutletsData.map(e => {
                              return (
                                <Select.Option value={e.id} key={e.id}>
                                  {e.outlet}
                                </Select.Option>
                              )
                            })}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Divider className='mt-3 mb-4' />
                </>
              )}

              {!getIsOwner && (
                <>
                  <Row className='Roles-div'>
                    <Col lg={6} md={24} sm={24} xs={24}>
                      <h2 class='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                        <IntlMessages id='setup.usersedit.roles' />
                      </h2>
                      <p className='dk-font-size-15'>
                        <IntlMessages id='setup.usersedit.rolesbrief' />
                      </p>
                    </Col>

                    <Col lg={18} md={24} sm={24} xs={24}>
                      <Form.Item
                        className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment form-inner-pad-0'
                        name='roles'
                        label={<IntlMessages id='setup.usersedit.roles' />}
                      >
                        <Select
                          size='large'
                          showSearch={checkIsWeb().exist}
                          optionFilterProp='children'
                        >
                          {getRolesData &&
                            getRolesData.length &&
                            getRolesData.map(e => {
                              return (
                                <Select.Option value={e.id} key={e.id}>
                                  {e.role}
                                </Select.Option>
                              )
                            })}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Divider className='mt-3 mb-4' />
                </>
              )}
              <Row className='Security -div'>
                <Col lg={6} md={24} sm={24} xs={24}>
                  <h2 class='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                    <IntlMessages id='setup.usersedit.security' />
                  </h2>
                  <p className='dk-font-size-15'>
                    <IntlMessages id='setup.usersedit.securitbrief1' />
                  </p>
                  <p className='dk-font-size-15'>
                    <IntlMessages id='setup.usersedit.securitbrief2' />
                  </p>
                </Col>

                <Col lg={18} md={24} sm={24} xs={24}>
                  <h2 class='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                    {!getUserId ? (
                      <IntlMessages id='setup.usersedit.securityhead' />
                    ) : (
                      <IntlMessages id='setup.usersedit.securityheadchange' />
                    )}
                  </h2>
                  <InputGroup size='large'>
                    <Form.Item
                      className='ant-form-item-label-custom ant-form-margin-right password-fix CreatePass-form form-inner-pad-0'
                      name='password'
                      label={<IntlMessages id='setup.usersedit.password' />}
                      rules={[
                        {
                          required: getUserId ? false : true,
                          message: (
                            <IntlMessages id='setup.usersedit.passwordrule' />
                          )
                        }
                      ]}
                      hasFeedback
                      {...{
                        help:
                          passwordStatus === '1'
                            ? ' '
                            : passwordStatus === '2'
                            ? 'Minimum length should be 8 characters'
                            : passwordStatus === '3'
                            ? 'At least 1 small case character required'
                            : passwordStatus === '4'
                            ? 'At least 1 upper case character required'
                            : passwordStatus === '5'
                            ? 'At least 1 special character required'
                            : passwordStatus == '6'
                            ? 'At least 1 numeric value'
                            : passwordStatus == '7'
                            ? 'Space Not Allowed In Password'
                            : 'Validating',
                        hasFeedback: true,
                        validateStatus:
                          passwordStatus === '1' ? 'success' : 'error'
                      }}
                    >
                      <Input.Password
                        size='large'
                        placeholder='Input Password'
                        iconRender={visible =>
                          visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                        }
                        disabled={
                          getIsOwner && !getIsLoggedInOwner ? true : false
                        }
                        onChange={onPassChange}
                      />
                    </Form.Item>

                    <Form.Item
                      className='ant-form-item-label-custom ant-form-margin-right password-fix CreatePass-form form-inner-pad-0'
                      name='confirm'
                      label={
                        <IntlMessages id='setup.usersedit.passwordconfirm' />
                      }
                      dependencies={['password']}
                      hasFeedback
                      rules={[
                        {
                          required: getUserId ? false : true,
                          message: 'Please confirm your password!'
                        },
                        ({ getFieldValue }) => ({
                          validator (rule, value) {
                            if (!value || getFieldValue('password') === value) {
                              return Promise.resolve()
                            }
                            return Promise.reject(
                              <IntlMessages id='setup.usersedit.passwordruleconfirm' />
                            )
                          }
                        })
                      ]}
                    >
                      <Input.Password
                        size='large'
                        placeholder='Repeat Password'
                        iconRender={visible =>
                          visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                        }
                        disabled={
                          getIsOwner && !getIsLoggedInOwner ? true : false
                        }
                      />
                    </Form.Item>
                  </InputGroup>
                </Col>
              </Row>
            </Form>
          </div>
        </Spin>
      </div>
    </>
  ) : (
    <NotAllowedComponent
      getAccessLoading={getAccessLoading}
      textType={!isFeatureAllowed ? 2 : 1}
    />
  )
}

export default AddEditUser
